import React from 'react';
import PageHeader from './PageHeader';

const Winners = () => {
    const winnersData = [
        {
          year: '2020',
          nominations: [
            {
              category: 'ИИ для оценки образовательных программ',
              team: 'EduTech Innovators',
              captain: 'Алексей Иванов (Россия) - IT-специалист с многолетним опытом разработки образовательных платформ, ведущий разработчик компании XYZ.',
              members: [
                'Мария Петрова (Украина) - Эксперт по образовательным технологиям',
                'Сергей Коваленко (Беларусь) - Разработчик инновационных учебных приложений'
              ],
              description: 'Команда разработала инновационную систему на основе ИИ для анализа и оценки образовательных программ, что позволило существенно улучшить качество обучения и адаптировать программы к индивидуальным потребностям студентов.'
            },
            {
              category: 'ИИ для анализа медицинских изображений',
              team: 'MediVision',
              captain: 'Анна Кузнецова (Казахстан) - Врач и IT-специалист, занимающийся разработкой медицинских приложений, ведущий эксперт компании ABC.',
              members: [
                'Дмитрий Васильев (Россия) - Разработчик систем ИИ для медицины',
                'Ольга Сергеева (Узбекистан) - Специалист по обработке медицинских данных'
              ],
              description: 'Команда разработала систему на основе ИИ для анализа медицинских изображений, что значительно улучшило диагностику заболеваний.'
            },
            {
              category: 'ИИ для управления городским трафиком',
              team: 'TrafficControl',
              captain: 'Виктор Сидоров (Беларусь) - Ведущий инженер-разработчик в компании DEF, специалист по транспортным системам.',
              members: [
                'Елена Мельникова (Украина) - Эксперт по городскому планированию',
                'Алексей Тихонов (Грузия) - Разработчик алгоритмов управления трафиком'
              ],
              description: 'Команда представила систему на основе ИИ для управления городским трафиком, что помогло снизить пробки и улучшить транспортную инфраструктуру.'
            }
          ]
        },
        {
          year: '2021',
          nominations: [
            {
              category: 'Прогнозирование и предотвращение природных пожаров с помощью ИИ',
              team: 'FireGuard AI',
              captain: 'Володимир Топозли (Украина) - Senior QA Automation engineer. Эксперт в области искусственного интеллекта и машинного обучения.',
              members: [
                'Екатерина Лебедева (Россия) - Специалист по анализу данных о природных явлениях',
                'Дмитрий Ковалев (Беларусь) - Разработчик систем прогнозирования'
              ],
              description: 'Команда разработала систему на основе ИИ, способную прогнозировать и предотвращать природные пожары, используя данные о погодных условиях, растительности и других факторов риска.'
            },
            {
              category: 'ИИ для финансового анализа и предсказаний',
              team: 'FinPredict',
              captain: 'Игорь Тертичко (Украина) - Специалист по разработке и внедрению масштабируемых решений, оптимизации производительности и предоставления высококачественных программных решений.',
              members: [
                'Марина Сидоренко (Казахстан) - Эксперт по финансовым прогнозам',
                'Денис Петренко (Таджикистан) - Разработчик финансовых моделей'
              ],
              description: 'Команда создала систему на основе ИИ для анализа финансовых данных и предсказания рыночных трендов.'
            },
            {
              category: 'ИИ для мониторинга окружающей среды',
              team: 'EcoWatch',
              captain: 'Виктор Кравченко (Грузия) - Эколог и IT-специалист, занимающийся разработкой систем мониторинга, ведущий разработчик компании DEF.',
              members: [
                'Ольга Смирнова (Россия) - Специалист по экологическим данным',
                'Алексей Лебедев (Украина) - Разработчик аналитических систем'
              ],
              description: 'Команда разработала систему на основе ИИ для мониторинга состояния окружающей среды и предсказания экологических рисков.'
            }
          ]
        },
        {
          year: '2022',
          nominations: [
            {
              category: 'ИИ на страже качества российских товаров',
              team: 'QualityControl AI',
              captain: 'Анна Петрова (Россия) - Эксперт в области качества и тестирования, ведущий инженер в компании GHI.',
              members: [
                'Михаил Савченко (Узбекистан) - Специалист по контролю качества',
                'Артем Карапетян (Армения) - Разработчик систем тестирования'
              ],
              description: 'Команда представила систему на основе ИИ для контроля качества российских товаров, что значительно повысило стандарты производства.'
            },
            {
              category: 'ИИ для медицинской диагностики',
              team: 'MediAI',
              captain: 'Иван Кравцов (Беларусь) - Врач и IT-специалист, занимающийся разработкой медицинских приложений, ведущий эксперт компании DEF.',
              members: [
                'Анна Иваненко (Украина) - Специалист по медицинским данным',
                'Сергей Николаев (Таджикистан) - Разработчик систем диагностики'
              ],
              description: 'Команда создала систему на основе ИИ для диагностики заболеваний, которая значительно улучшила точность и скорость постановки диагнозов.'
            },
            {
              category: 'ИИ для предсказания и предотвращения кибератак',
              team: 'CyberGuard',
              captain: 'Олег Петров (Казахстан) - Специалист по кибербезопасности, ведущий эксперт компании XYZ.',
              members: [
                'Елена Сергеева (Грузия) - Эксперт по анализу угроз',
                'Андрей Волков (Россия) - Разработчик систем защиты'
              ],
              description: 'Команда разработала систему на основе ИИ для предсказания и предотвращения кибератак, что значительно повысило уровень безопасности корпоративных сетей.'
            }
          ]
        },
        {
          year: '2023',
          nominations: [
            {
              category: 'ИИ для оптимизации транспортных потоков',
              team: 'TrafficAI',
              captain: 'Алексей Кравцов (Молдова) - Специалист по транспортным системам и аналитике данных, руководитель отдела разработок в компании JKL.',
              members: [
                'Анна Серова (Россия) - Эксперт по городскому планированию',
                'Дмитрий Иваненко (Украина) - Разработчик алгоритмов управления трафиком'
              ],
              description: 'Команда разработала систему на основе ИИ для оптимизации транспортных потоков в городах, что значительно снизило заторы и улучшило транспортную инфраструктуру.'
            },
            {
              category: 'ИИ для прогнозирования экономических трендов',
              team: 'EconoPredict',
              captain: 'Виктория Белова (Армения) - Экономист и IT-специалист, ведущий аналитик компании DEF.',
              members: [
                'Елена Морозова (Грузия) - Специалист по экономическому анализу',
                'Алексей Никифоров (Россия) - Разработчик аналитических систем'
              ],
              description: 'Команда создала систему на основе ИИ для прогнозирования экономических трендов и анализа рыночных данных.'
            },
            {
              category: 'ИИ для анализа и управления энергетическими системами',
              team: 'EnergyAI',
              captain: 'Сергей Мельников (Беларусь) - Эксперт в области энергетики и IT, руководитель проектов в компании XYZ.',
              members: [
                'Марина Иванова (Казахстан) - Специалист по энергетическим системам',
                'Ольга Смирнова (Узбекистан) - Разработчик систем управления'
              ],
              description: 'Команда разработала систему на основе ИИ для анализа и управления энергетическими системами, что значительно повысило эффективность использования энергетических ресурсов.'
            }
          ]
        },
        {
          year: '2024',
          nominations: [
            {
              category: 'ИИ для управления водными ресурсами',
              team: 'WaterControl AI',
              captain: 'Николай Сергеев (Россия) - Эксперт в области экологии и IT, ведущий инженер в компании DEF.',
              members: [
                'Виктория Сидоренко (Украина) - Специалист по управлению водными ресурсами',
                'Георгий Меладзе (Грузия) - Разработчик аналитических систем'
              ],
              description: 'Команда представила систему на основе ИИ для управления водными ресурсами, что помогло значительно улучшить качество и распределение воды.'
            },
            {
              category: 'ИИ для анализа и предсказания потребительского поведения',
              team: 'ConsumerPredict',
              captain: 'Тимур Абдуллаев (Узбекистан) - Специалист по маркетингу и аналитике данных, ведущий аналитик компании XYZ.',
              members: [
                'Армен Петросян (Армения) - Эксперт по потребительскому поведению',
                'Лариса Баранова (Беларусь) - Разработчик аналитических систем'
              ],
              description: 'Команда создала систему на основе ИИ для анализа и предсказания потребительского поведения, что позволило компаниям лучше понимать и удовлетворять потребности своих клиентов.'
            },
            {
              category: 'ИИ для мониторинга и улучшения состояния здоровья населения',
              team: 'HealthWatch AI',
              captain: 'Алексей Тихомиров (Казахстан) - Врач и IT-специалист, занимающийся разработкой медицинских приложений, ведущий эксперт компании JKL.',
              members: [
                'Елена Сафронова (Россия) - Специалист по медицинским данным',
                'Дмитрий Романов (Таджикистан) - Разработчик систем мониторинга здоровья'
              ],
              description: 'Команда разработала систему на основе ИИ для мониторинга и улучшения состояния здоровья населения, что значительно повысило качество медицинского обслуживания.'
            }
          ]
        }
      ];
      

  return (
    <div >
        <PageHeader title="Победители" />
        <div className="winners-container">
      {winnersData.map((yearData, yearIndex) => (
        <div key={yearIndex} className="year-section">
          <h2 className="year-title">Победители {yearData.year} года</h2>
          <table className="nomination-table">
            <thead>
              <tr>
                <th>Номинация</th>
                <th>Команда</th>
                <th>Капитан</th>
                <th>Участники</th>
                <th>Описание</th>
              </tr>
            </thead>
            <tbody>
              {yearData.nominations.map((nomination, nomIndex) => (
                <tr key={nomIndex}>
                  <td>{nomination.category}</td>
                  <td>{nomination.team}</td>
                  <td>{nomination.captain}</td>
                  <td>
                    {nomination.members.map((member, memberIndex) => (
                      <p key={memberIndex}>{member}</p>
                    ))}
                  </td>
                  <td>{nomination.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
    </div>
  );
};

export default Winners;